import { action, observable, reaction } from "mobx";
import { findIndex, keys, orderBy } from "lodash";
import { ConsultantEditorStore } from "../ConsultantEditorStore";

export class ProfessionSelectionStore {
  @observable selectedProfessions: string[];
  @observable currentProfession: string;
  @observable showProfessionSelector: boolean;

  constructor(private editorStore: ConsultantEditorStore) {
    this.selectedProfessions = [];
    this.currentProfession = undefined;
    this.showProfessionSelector = false;

    reaction(
      () => this.editorStore.form.values.expertise,
      (e) => {
        e && this.setupSelectedProfession();
      }
    );
  }

  get professions() {
    return orderBy(
      this.editorStore.allProfessions.filter((x) => !this.selectedProfessions.includes(x))
    );
  }

  @action setShowProfessionSelector = (b: boolean) => {
    this.showProfessionSelector = b;
  };

  @action setCurrentProfession = (p: string) => {
    this.currentProfession = p;
  };

  @action setCurrentProfessionDefault = () => {
    this.currentProfession =
      this.selectedProfessions.length > 0 ? this.selectedProfessions[0] : undefined;
  };

  @action professionSelectionClose = () => {
    this.showProfessionSelector = false;
    this.setCurrentProfessionDefault();
  };

  @action professionSelect = (p: string) => {
    this.showProfessionSelector = false;
    this.selectedProfessions.push(p);
    this.currentProfession = p;
  };

  @action removeProfession = (p: string) => {
    const i = findIndex(this.selectedProfessions, (x) => x === p);
    if (i !== -1) {
      this.selectedProfessions.splice(i, 1);
      this.setCurrentProfessionDefault();
    }
  };

  private setupSelectedProfession() {
    if (this.editorStore.isNew) {
      // switched off by Henrik's request
      // this.selectedProfessions = this.editorStore.professionsByTeams.slice(0, 3);
    } else {
      const { expertise } = this.editorStore.form.values;
      if (!expertise) {
        return;
      }
      const profKeys = keys(expertise);
      this.selectedProfessions = profKeys
        .filter((x) => expertise[x]?.professionName)
        .map((y) => expertise[y]?.professionName);
    }

    this.setCurrentProfessionDefault();
  }
}
